<template>
    <div class="webbook">
        <div v-html="this.$parent.webbook[node]"></div>
        <div v-if="!this.$parent.webbook[node]">
                Lade Text...
                <font-awesome-icon icon="spinner" spin/>
        </div>
        <div id='login-button' v-if="node=='welcome'">
            <router-link :to="{ name: 'Login' }">
                <span class="btn">Zum Login</span>
            </router-link>
        </div>
    </div>    
</template>

<script>
export default {
    name: "Webbook",
    props: {       
        node: String 
    },
    created() {
    },
    data() {
        return {
        };
    },    
    methods: {
    }
};
</script>

<style lang="css" src="../assets/css/Webbook.css"/>